import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
} from "./types";

import authService from "../services/auth.service";

// login action: persist token + roles to localStorage.user as { username, accessToken, roles, ... }
export const login = (username, password) => async (dispatch) => {
  try {
    const res = await authService.login(username, password);
    const data = res.data || {};
    const accessToken = data.accessToken || data.token || data.access_token || null;
    const roles = data.roles || data.authorities || data.role || [];

    const user = {
      username: data.username || username,
      accessToken,
      roles,
      ...data,
    };

    localStorage.setItem("user", JSON.stringify(user));

    dispatch({
      type: LOGIN_SUCCESS,
      payload: { user },
    });

    return Promise.resolve(res);
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || error.message || "Login failed";
    dispatch({
      type: LOGIN_FAIL,
    });
    dispatch({
      type: SET_MESSAGE,
      payload: message,
    });
    return Promise.reject(error);
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("user");
  dispatch({ type: LOGOUT });
};
